import { FC, useContext,memo } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "src/context/authContext";
import { sp_treatments_data } from "src/pages/actionDashboard/types";
import ManufacturerNextStepActions from "../manufactureNextStepActions";

type Props = {
  data: sp_treatments_data;
  refreshListing: () => void;
};

const PharmacyTableRow: FC<Props> = ({
  data,
  refreshListing
}) => {
  const { isManufacturer } = useContext(AuthContext);
  //.log("PharmacyTableRow.....",data)
  return (
    <tr>
      {/* Patient Name */}
      {data.patient_name !== "Redacted" ? (
        <td className="text-center align-middle">
          <Link to={`/global_patients/${data.patient_id}${isManufacturer ? "" : "/edit"}`}>
            {data.patient_name}
          </Link>
        </td>
      ) : (
        <td className="text-center align-middle">{data.patient_name}</td>
      )}

      {/* Patient ID */}
      <td className="text-center align-middle">
        <Link 
          to={`/global_patients/${data.patient_id}${isManufacturer ? "" : "/edit"}`}
          className={`${data.drug_name === "iovera°" ? 'text-iovera' : 'text-zilretta'} `}
        >
          {data.patient_id}
        </Link>
      </td>

      {/* Case ID */}
      <td className="text-center align-middle">
        <Link 
          to={`/cases/detail/${data.bi_case_id}`}
          className={`${data.drug_name === "iovera°" ? 'text-iovera' : 'text-zilretta'} `}  
        >
          {data.bi_case_id}
        </Link>
      </td>
      <td className="text-center align-middle">
       {data.drug_name}
      </td>
      {/* Provider */}
      <td className="text-center align-middle">
        {typeof data.provider === "boolean" && data.provider ? (
          <button type="button" className="btn btn-green">{data.provider}</button>
        ) : typeof data.provider === "string" && <span>{data.provider}</span>}
      </td>
       <td className="align-middle">
           <span className={`badge background-color-${data.pharmacy_sp_status_color}`}>
                {data.pharmacy_sp_status}
           </span>
      </td>
      {/* <td className="align-middle">
          {data.copay_status}
      </td> */}
      

      {/* Next Steps (buttons) */}
      <td className="text-center align-middle">
       <ManufacturerNextStepActions refreshListing={refreshListing} kase={data} next_steps={data.next_steps}/>
      </td>
    

      {/* Rest of columns */}
      <td className="text-center align-middle">{isManufacturer ? data.sp_transferred_to : data.sp_transfered_to}</td>
      <td className="text-center align-middle">{data.date_transferred}</td>
      <td className="text-center align-middle">{data.status_update?.status && (
        <span title={data.status_update.status}>
          <i className="fas fa-info-circle fa-lg text-color-yellow" style={{ color: "#f2ba45" }}></i>
        </span>
      )}</td>
      <td className="text-center align-middle">{data.date_shipped}</td>
      {/* <td className="text-center align-middle">{data.carrier}</td>
      <td className="text-center align-middle">{data.tracking_number}</td> */}
  {/* Status */}
     
    </tr>
  );
};

export default memo(PharmacyTableRow);
